import { render, staticRenderFns } from "./equipmentDetail.vue?vue&type=template&id=5af46a38&scoped=true&"
import script from "./equipmentDetail.vue?vue&type=script&lang=js&"
export * from "./equipmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./equipmentDetail.vue?vue&type=style&index=0&id=5af46a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af46a38",
  null
  
)

export default component.exports